//import { TextField } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { Table, Image } from "react-bootstrap";
import BasicPagination from "../../../../Pagination/Pagination";
import moment from "moment";
import { NOTAVAILABLEIMAGE } from "../../../../../enums/GlobalEnums";

const WalletScanPayPageComponent = (props) => {
  //state

  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  let filteredData = props.data;

  if (props.search) {
    filteredData = filteredData.filter((item) => {
      return (
        item?.restaurant_id?.restaurant_name
          ?.toLowerCase()
          .includes(props.search.toLowerCase()) ||
        item?._id?.includes(props.search) ||
        item?.transactionNumber?.toString().includes(props.search)
      );
    });
  }

  if (props.sortBy === "Date & Time 🠑") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
  } else if (props.sortBy === "Date & Time 🠓") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    );
  } else if (props.sortBy === "A-Z") {
    filteredData = filteredData?.sort((a, b) =>
      a.restaurant_id?.restaurant_name > b.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  } else if (props.sortBy === "Z-A") {
    filteredData = filteredData?.sort((a, b) =>
      b.restaurant_id?.restaurant_name > a.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  }

  if (props?.filterBy) {
    console.log(props?.filterBy, "************88");
    if (props?.filterBy?.wType)
      filteredData = filteredData?.filter(
        (ele) =>
          ele.payment_method?.toLowerCase() ===
          props?.filterBy?.wType?.toLowerCase()
      );
    if (props?.filterBy?.tType)
      filteredData = filteredData?.filter(
        (ele) =>
          ele.transaction_type?.toLowerCase() ===
          props?.filterBy?.tType?.toLowerCase()
      );
    if (
      props?.filterBy?.captured === true ||
      props?.filterBy?.captured === false
    )
      filteredData = filteredData?.filter(
        (ele) => ele.payment_captured === props?.filterBy.captured
      );
  }

  useEffect(() => {
    // setSortBy("");
    // setSortName([]);
    setPage(1);
    setStart(0);
    setEnd(10);
  }, [props.search]);
  return (
    <>
      <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
        <Table className="enMinWidth900">
          <thead>
            <tr className="super_admin_all_users_table_head">
              <th style={{ width: "12%" }} className="f12-700">
                Transaction ID
              </th>
              <th style={{ width: "15%" }} className="f12-700">
                Payment To
              </th>
              <th style={{ width: "8%" }} className="f12-700">
                Payment
                <br /> Method
              </th>
              <th style={{ width: "10%" }} className="f12-700">
                Transaction <br />
                Type
              </th>
              <th style={{ width: "10%" }} className="f12-700">
                Status
              </th>
              <th style={{ width: "15%" }} className="f12-700">
                Date & Time
              </th>
              <th style={{ width: "8%" }} className="f12-700">
                Amount
              </th>
              <th style={{ width: "9%" }} className="f12-700">
                Reference ID/ <br />
                Order Type
              </th>
              <th style={{ width: "9%" }} className="f12-700">
                Cashback
              </th>
            </tr>
          </thead>
          <tbody className="HideShowTable">
            {filteredData.slice(start, end).map((payment, index) => {
              return (
                <tr
                  className="super_admin_all_users_table_body super_admin_user_view_inside_table_body"
                  key={index}
                >
                  <td style={{ width: "12%" }}>
                    <div className="f12-400 text-break">
                      {payment.transactionNumber || payment._id}
                    </div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="d-flex align-items-center">
                      <div>
                        <Image
                          src={
                            (payment &&
                              payment.restaurant_id &&
                              payment.restaurant_id.logo_url) ||
                            NOTAVAILABLEIMAGE
                          }
                          alt="restaurant logo"
                          title="restaurant logo"
                          className="enIMG28Round"
                        />
                      </div>
                      <div className="pl-2">
                        <div className="f12-400">
                          {" "}
                          {(payment &&
                            payment.restaurant_id &&
                            payment.restaurant_id.restaurant_name) ||
                            `N/A`}
                        </div>
                        <div className="f10-400">
                          {" "}
                          {payment &&
                            payment.restaurant_id &&
                            payment.restaurant_id.city}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "8%" }}>
                    <div className="f12-400">
                      {payment && payment.payment_method}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">
                      {payment?.transaction_type === "WALLET"
                        ? "Wallet"
                        : payment?.transaction_type === "RAZORPAY"
                        ? "Razorpay"
                        : "Scan & Pay"}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div
                      className={`${
                        !payment.payment_captured
                          ? `enPendingLBL`
                          : `enSuccessLBL`
                      }`}
                    >
                      {!payment.payment_captured
                        ? "Pending/Failure"
                        : "Success"}
                        {!payment.payment_captured}
                    </div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="f12-400">
                      {moment(payment.createdAt).format("Do MMMM YYYY")}
                    </div>
                    <div className="f12-400">
                      {moment(payment.createdAt).format("LT")}
                    </div>
                  </td>
                  <td style={{ width: "8%" }}>
                    <div className="f12-400">
                      <b>₹ </b>
                      {payment && payment.amount && payment.amount.toFixed(2)}
                    </div>
                  </td>
                  <td style={{ width: "9%" }}>
                    <div className="f12-400 text-break">
                      {payment && payment.order_id} <br />
                      {payment &&
                      payment.orderId &&
                      payment.orderId.order_type === 0
                        ? "Take Away"
                        : payment &&
                          payment.orderId &&
                          payment.orderId.order_type === 1
                        ? "Curb Side"
                        : payment &&
                          payment.orderId &&
                          payment.orderId.order_type === 2
                        ? "Skip The Line"
                        : payment &&
                          payment.orderId &&
                          payment.orderId.order_type === 3
                        ? "Dine In"
                        : "N/A"}
                    </div>
                  </td>
                  <td style={{ width: "9%" }}>
                    <div className="f12-400">{/* <b>₹ </b>50 */}</div>
                  </td>
                </tr>
              );
            })}
          </tbody>
          {/* <tbody className="HideShowTable">
            {[0, 1, 2].map((data, index) => {
              return (
                <tr className="super_admin_all_users_table_body super_admin_user_view_inside_table_body">
                  <td style={{ width: "15%" }}>
                    <div className="f12-400">1245789632</div>
                  </td>
                  <td style={{ width: "18%" }}>
                    <div className="d-flex align-items-center">
                      <div>
                        <Image
                          src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                          alt="View"
                          title="View"
                          className="enIMG28Round"
                        />
                      </div>
                      <div className="pl-2">
                        <div className="f12-400">Kelly McDonald</div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "12%" }}>
                    <div className="f12-400">Card</div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="f12-400">Requested To</div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="enSuccessLBL">Success</div>
                  </td>
                  <td style={{ width: "20%" }}>
                    <div className="f12-400">25th Aug, 2020</div>
                    <div className="f12-400">09:15 PM</div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">
                      <b>₹ </b>900
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody> */}
          {/* <tbody className="HideShowTable">
            <tr className="super_admin_all_users_table_body super_admin_user_view_inside_table_body">
              <td style={{ width: "15%" }}>
                <div className="f12-400">1245789632</div>
              </td>
              <td style={{ width: "18%" }}>
                <div className="d-flex align-items-center">
                  <div>
                    <Image
                      src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                      alt="View"
                      title="View"
                      className="enIMG28Round"
                    />
                  </div>
                  <div className="pl-2">
                    <div className="f12-400">Kelly McDonald</div>
                  </div>
                </div>
              </td>
              <td style={{ width: "12%" }}>
                <div className="f12-400">Card</div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f12-400">Deposit</div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="enSuccessLBL">Success</div>
              </td>
              <td style={{ width: "20%" }}>
                <div className="f12-400">25th Aug, 2020</div>
                <div className="f12-400">09:15 PM</div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="f12-400">
                  <b>₹ </b>900
                </div>
              </td>
            </tr>
          </tbody>
          <tbody className="HideShowTable">
            <tr className="super_admin_all_users_table_body super_admin_user_view_inside_table_body">
              <td style={{ width: "15%" }}>
                <div className="f12-400">1245789632</div>
              </td>
              <td style={{ width: "18%" }}>
                <div className="d-flex align-items-center">
                  <div>
                    <Image
                      src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                      alt="View"
                      title="View"
                      className="enIMG28Round"
                    />
                  </div>
                  <div className="pl-2">
                    <div className="f12-400">Kelly McDonald</div>
                  </div>
                </div>
              </td>
              <td style={{ width: "12%" }}>
                <div className="f12-400">Scan & Pay</div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f12-400">Transferred</div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="enSuccessLBL">Success</div>
              </td>
              <td style={{ width: "20%" }}>
                <div className="f12-400">25th Aug, 2020</div>
                <div className="f12-400">09:15 PM</div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="f12-400">
                  <b>₹ </b>900
                </div>
              </td>
            </tr>
          </tbody>
          <tbody className="HideShowTable">
            <tr className="super_admin_all_users_table_body super_admin_user_view_inside_table_body">
              <td style={{ width: "15%" }}>
                <div className="f12-400">1245789632</div>
              </td>
              <td style={{ width: "18%" }}>
                <div className="d-flex align-items-center">
                  <div>
                    <Image
                      src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                      alt="View"
                      title="View"
                      className="enIMG28Round"
                    />
                  </div>
                  <div className="pl-2">
                    <div className="f12-400">Kelly McDonald</div>
                  </div>
                </div>
              </td>
              <td style={{ width: "12%" }}>
                <div className="f12-400">Scan & Pay</div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f12-400">Payment Sent</div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="enPendingLBL">Pending</div>
              </td>
              <td style={{ width: "20%" }}>
                <div className="f12-400">25th Aug, 2020</div>
                <div className="f12-400">09:15 PM</div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="f12-400">
                  <b>₹ </b>900
                </div>
              </td>
            </tr>
          </tbody>
          <tbody className="HideShowTable">
            <tr className="super_admin_all_users_table_body super_admin_user_view_inside_table_body">
              <td style={{ width: "15%" }}>
                <div className="f12-400">1245789632</div>
              </td>
              <td style={{ width: "18%" }}>
                <div className="d-flex align-items-center">
                  <div>
                    <Image
                      src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                      alt="View"
                      title="View"
                      className="enIMG28Round"
                    />
                  </div>
                  <div className="pl-2">
                    <div className="f12-400">Kelly McDonald</div>
                  </div>
                </div>
              </td>
              <td style={{ width: "12%" }}>
                <div className="f12-400">Scan & Pay</div>
              </td>
              <td style={{ width: "15%" }}>
                <div className="f12-400">Requested From</div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="enCancelledLBL">Cancelled</div>
              </td>
              <td style={{ width: "20%" }}>
                <div className="f12-400">25th Aug, 2020</div>
                <div className="f12-400">09:15 PM</div>
              </td>
              <td style={{ width: "10%" }}>
                <div className="f12-400">
                  <b>₹ </b>900
                </div>
              </td>
            </tr>
          </tbody> */}
        </Table>
      </div>
      {filteredData.length !== 0 ? (
        <BasicPagination
          totalRecords={filteredData.length}
          limit={10}
          batch={page}
          onBatchChange={(e) => handleBatchChange(e)}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default WalletScanPayPageComponent;
